import { ref } from 'vue'
import { defineStore } from 'pinia'

// 定义配置数据类型
interface ConfigData {
  // 根据你的实际配置数据结构定义类型
  [key: string]: any
}

// 定义新闻详情数据类型
interface NewsDetail {
  title: string
  date: string
  content: string
  [key: string]: any // 支持其他字段
}

// 定义产品详情数据类型
interface MaterialDetail {
  [key: string]: any
}

export const useConfigStore = defineStore('config', () => {
  // 存储配置数据的状态
  const configData = ref<ConfigData | null>(null)
  // 存储新闻详情数据
  const newsDetail = ref<NewsDetail | null>(null)
  // 存储产品详情数据
  const materialDetail = ref<MaterialDetail | null>(null)

  // 设置配置数据
  const setConfigData = (data: ConfigData) => {
    configData.value = data
  }
  // 获取特定配置项
  const getConfigItem = (key?: string) => {
    if(key){
      return configData.value?.[key]
    } else {
      return configData.value
    }
  }

  // 设置新闻详情数据
  const setNewsDetail = (data: NewsDetail) => {
    newsDetail.value = data
  }
  // 获取新闻详情数据
  const getNewsDetail = () => {
    return newsDetail.value
  }
  // 清除新闻详情数据
  const clearNewsDetail = () => {
    newsDetail.value = null
  }
  
  // 设置产品详情数据
  const setMaterialDetail = (data: MaterialDetail) => {
    materialDetail.value = data
  }
  // 获取产品详情数据
  const getMaterialDetail = () => {
    return materialDetail.value
  }

  return {
    configData,
    newsDetail,
    materialDetail,
    setConfigData,
    getConfigItem,
    setNewsDetail,
    getNewsDetail,
    clearNewsDetail,
    setMaterialDetail,
    getMaterialDetail,
  }
}, {
  // 添加持久化配置
  persist: {
    key: 'config-store', // 自定义存储键名
    storage: localStorage, // 使用localStorage存储
    paths: ['newsDetail', 'materialDetail'] // 只持久化这些字段
  }
})